<div class="placeholder" (click)="close()" class="preview">
    <img *ngIf="!data.file?.url" [src]="data.thumbnail" class="border">
    <img *ngIf="data.file?.url" [src]="data.file?.url" class="border">
</div>